import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Select,
  Card,
  Form,
  Space,
  message,
  Image,
  Empty,
  Checkbox,
  InputNumber
} from 'antd';
import styles from '@/common/Layout/index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import { QrcodeOutlined, DeleteOutlined } from '@ant-design/icons';
import { QrReader } from 'react-qr-reader';
import Layout from '@/common/Layout';
import CustomTable from '@/common/Content/CustomTable';
import { useDispatch } from 'react-redux';
import {
  updatebinposition,
  getContainers,
  getbinContainers,
  deletebinContainers,
  getBatchDetails
} from '../../redux/slice';
import moment from 'moment';
import { history } from 'app/history';
import scanning from '../../images/scanning.gif';
import CustomModal from '@/common/CustomModal';
import { getLoggedInUser } from 'utilities/helpers';
import { getProducts } from '@/features/productionLabelGen/redux/slice';

const UpdateBinPage = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [openCam, setOpenCam] = useState(false);
  const [openConatCam, setOpenConatCam] = useState(false);
  const [data, setData] = useState([]);
  const [bin, setBin] = useState('');
  const [binList, setBinList] = useState([]);
  const [containers, setContainers] = useState([]);
  const [binContainers, setBinContainers] = useState([]);
  const [scan, setScan] = useState(false);
  const [bindata, setBindata] = useState(false);
  const [bincard, setBincard] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [bindet, setBindet] = useState('');
  const [ismodal, setIsmodal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [binLocationsdata, setBinLocationsdata] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { user } = getLoggedInUser();
  // Production bin flow covers both production roles. The backend branches on
  // prod_user || prod_ebmr, so the UI must match or a prod_user gets the
  // warehouse screens over the production controller branch.
  const isProdRole = ['prod_user', 'prod_ebmr'].includes(user?.role);

  // Reset to the first page whenever the bin's container list changes.
  useEffect(() => {
    setPage(1);
  }, [binList]);

  // binList can be set to undefined when a bin search/scan returns no match
  // (get-details responds with null data) — guard so the page never crashes.
  const pagedBinList = (binList || []).slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const onFinish = (values) => {
    const batch_numbers = [];
    data?.map((data) => {
      batch_numbers.push(data?.[0]?.id);
    });
    // Warehouse captures a quantity per placement. Mandatory and >= 0; a blank
    // is rejected here rather than silently stored as "not captured" (NULL),
    // which is reserved for legacy rows and callers that have no qty input.
    if (!isProdRole) {
      const invalid = data?.some((row) => {
        const q = row?.[0]?.qty;
        return q === '' || q === null || q === undefined || Number(q) < 0;
      });
      if (invalid) {
        message.error('Enter a quantity of 0 or more for every batch');
        return;
      }
    }
    setScan(true);
    values['batch_numbers'] = batch_numbers;
    // Side-channel carrying only the quantities. batch_numbers still decides
    // which batches are placed, so the backend's control flow is unchanged.
    if (!isProdRole) {
      values['batch_items'] = data?.map((row) => ({
        id: row?.[0]?.id,
        qty: Number(row?.[0]?.qty)
      }));
    }
    values['bin_no'] = bin;
    dispatch(updatebinposition(values)).then(function (response) {
      if (response?.payload?.success) {
        setTimeout(() => {
          form.resetFields();
          setData([]);
          setBin('');

          setBinList(response?.payload?.data?.batch_bin_locations);
          setScan(false);
        }, 2000);
      } else {
        setScan(false);
      }
    });
  };

  const handleBinPosition = () => {
    setScan(true);
    // values['container_numbers'] = selectedRowKeys;
    // values['bin_no'] = bindet;

    const payload = { bin_numbers: selectedRowKeys, bin_no: bindet };
    dispatch(updatebinposition(payload)).then(function (response) {
      if (response?.payload?.success) {
        setTimeout(() => {
          form.resetFields();
          setData([]);
          setBindet('');
          setBinList(response?.payload?.data?.batch_bin_locations);
          setScan(false);
          history.push('/landingpage');
        });
      } else {
        setScan(false);
      }
    });
  };
  const handleError = (err) => {
    console.error(err);
  };
  const handleClose = () => {
    setIsmodal(false);
  };
  const handleSubmit = () => {
    selectedRowKeys;
    // binLocationsdata.containers.includes(selectedRowKeys);

    let filtereditems = [];

    binLocationsdata.containers.map((id) => {
      // filtereditems.push(id.id);
      selectedRowKeys.map((item) => {
        if (id.number === item) {
          filtereditems.push({ container_id: id.id });
        }
      });
    });
    const payload = { remove_containers: filtereditems };
    dispatch(deletebinContainers(payload)).then(function (response) {
      if (response?.payload?.success) {
        message.success('Containers deleted successfully');
        setIsmodal(false);
        history.push('/updatebin');
      }
    });
  };
  // Product batches read as "BATCH (Process › SubProcess)", matching the
  // Product Batch Number column in the table below. A batch_no alone is
  // ambiguous — the same product batch appears once per dispensing event, so
  // the picker showed several identical-looking options.
  //
  // Coating etc. carry the process on the dispensing request; Compression /
  // Inspection have no request and carry it on the dispense itself. The API
  // renames 'dispensing-request' to 'dispensing_request', so accept both.
  const formatProdBatchLabel = (item) => {
    const dr = item?.dispensing_request || item?.['dispensing-request'];
    const sub = dr?.prod_label_sub_process?.sub_process_name;
    const name =
      dr?.prod_label_process_master?.process_label_name ||
      item?.prod_label_process_master?.process_label_name;
    const suffix =
      name || sub ? ` (${name || 'NA'}${sub ? ` › ${sub}` : ''})` : '';
    return `${item?.batch_no || 'NA'}${suffix}`;
  };

  const onChange = (values) => {
    const batches = containers?.filter((batch) => batch.id === values);
    if (!isProdRole) {
      if (batches?.[0]?.inhouse_batch_number.length > 0) {
        // Match on the staged row's batch id. The previous check compared the
        // row (an array) against a batch-number string, so it never matched and
        // the same batch could be staged twice. That now matters: the backend
        // adds a repeat placement onto the existing quantity, so a double-add
        // in one submit would be counted twice.
        let duplicate = data?.length
          ? data.filter((row) => row?.[0]?.id === batches?.[0]?.id)
          : [];
        duplicate?.length === 0
          ? setData([
              ...data,
              [
                {
                  id: batches?.[0]?.id,
                  batch: batches?.[0]?.inhouse_batch_number,
                  material_id: batches?.[0]?.material?.code,
                  material_name: batches?.[0]?.material?.name,
                  // UOM is display-only, read straight from the material master
                  // (never persisted against the bin placement).
                  uom: batches?.[0]?.material?.uom,
                  qty: ''
                }
              ]
            ])
          : message.error(
              'This batch is already staged — edit its quantity instead of adding it twice'
            );
        form.resetFields();
      }
    } else {
      setData([
        ...data,
        [
          {
            id: batches?.[0]?.id,
            batch: formatProdBatchLabel(batches?.[0]),
            // Compression / Inspection dispenses have no product_id and carry
            // the name on product_name instead — same fallback the bin-detail
            // table uses, so the staged row is no longer blank for them.
            material_name:
              batches?.[0]?.product_detail?.name || batches?.[0]?.product_name
          }
        ]
      ]);
      form.resetFields();
    }
  };

  const onChangebin = (values) => {
    setBin(values);

    // if (user?.role === 'prod_user') {
    //   const payload = { search: values };
    //   dispatch(getProducts(payload)).then(function (response) {
    //     if (response?.payload?.success) {
    //       form.resetFields();
    //       setBindata(true);
    //       setBinLocationsdata(response?.payload?.data);
    //       setBinList(response?.payload?.data?.batch_bin_locations);
    //     }
    //   });
    // } else {
    const payload = { id: values };
    dispatch(getbinContainers(payload)).then(function (response) {
      if (response?.payload?.success) {
        form.resetFields();
        setBindata(true);
        setBinLocationsdata(response?.payload?.data);
        setBinList(
          isProdRole
            ? response?.payload?.data?.prod_bin_locations
            : response?.payload?.data?.batch_bin_locations
        );
      }
    });
    // }

    form.resetFields();
  };

  const onChangebinnum = (values) => {
    setBindet(values);
    const payload = { id: values };
    dispatch(getbinContainers(payload)).then(function (response) {
      if (response?.payload?.success) {
        form.resetFields();
        // setBinList(response?.payload?.data?.containers);
      }
    });
    form.resetFields();
  };

  const onSearch = (value) => {
    if (value?.length > 6) {
      const payload = { search: value };
      isProdRole
        ? dispatch(getProducts(payload)).then(function (response) {
            if (response?.payload?.success) {
              setContainers(response?.payload?.data);
            }
          })
        : dispatch(getBatchDetails(payload)).then(function (response) {
            if (response?.payload?.success) {
              setContainers(response?.payload?.data);
            }
          });
    }
  };
  const onSearchbin = (value) => {
    if (value?.length > 2) {
      const payload = { id: value };
      dispatch(getContainers(payload)).then(function (response) {
        if (response?.payload?.success) {
          setBinContainers(response?.payload?.data);
        }
      });
    }
  };

  const handleQrScan = async (scanData) => {
    // scanData.stopPropagation();
    if (scanData && scanData !== '') {
      // scanData.text
      //   .slice(scanData.text.lastIndexOf('/') + 1)
      //   .substring(0, 3) !== 'CSN'
      //   ?
      //   setBin(scanData.text.slice(scanData.text.lastIndexOf('/') + 1))

      //   : message.error('This scanned Bin  is not valid');

      if (
        scanData.text
          .slice(scanData.text.lastIndexOf('/') + 1)
          .substring(0, 3) !== 'CSN'
      ) {
        setBin(scanData.text.slice(scanData.text.lastIndexOf('/') + 1));
        const payload = {
          id: scanData.text.slice(scanData.text.lastIndexOf('/') + 1)
        };
        dispatch(getbinContainers(payload)).then(function (response) {
          if (response?.payload?.success) {
            form.resetFields();
            setBindata(true);
            setOpenCam(false);
            setBinLocationsdata(response?.payload?.data);
            setBinList(
              isProdRole
                ? response?.payload?.data?.prod_bin_locations
                : response?.payload?.data?.batch_bin_locations
            );
          }
        });
      } else {
        message.error('This scanned Bin  is not valid');
        setOpenCam(false);
      }
    }
  };
  const handleContainerQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      scanData.text.slice(scanData.text.lastIndexOf('/') + 1).substring(0, 3) ==
      'CSN'
        ? setData([
            ...data,
            scanData.text.slice(scanData.text.lastIndexOf('/') + 1)
          ])
        : message.error('This scanned Container  is not valid');
      setOpenConatCam(false);
    }
  };
  const removeConatiner = (id) => {
    const list = [...data];
    list.splice(id, 1);
    setData(list);
  };

  // Qty is captured per staged batch, not once per submit — "Add & Scan Next
  // Bin" posts every staged row against the one scanned bin.
  const handleQtyChange = (value, index) => {
    const list = [...data];
    list[index] = [{ ...list[index]?.[0], qty: value }];
    setData(list);
  };

  const columns = !isProdRole
    ? [
        {
          title: 'Bin Number',
          dataIndex: 'current_location',
          key: 'current_location',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) =>
            a?.current_location?.localeCompare(b?.current_location),
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },
        {
          title: 'Inhouse Batch Number',
          dataIndex: 'number',
          key: 'number',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) => a?.number?.localeCompare(b?.number),
          render: (text, record) => {
            return record?.batch_detail?.inhouse_batch_number;
          },
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },

        {
          title: 'Material Code',
          dataIndex: 'document_verification',
          key: 'document_verification',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) =>
            a?.batch_detail?.material?.name?.localeCompare(
              b?.batch_detail?.material?.name
            ),
          render: (text, record) => {
            return record?.batch_detail?.material?.code;
          },
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },
        {
          title: 'Material Name',
          dataIndex: 'document_verification',
          key: 'document_verification',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) =>
            a?.batch_detail?.material?.name?.localeCompare(
              b?.batch_detail?.material?.name
            ),
          render: (text, record) => {
            return record?.batch_detail?.material?.name;
          },
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },
        {
          title: 'UOM',
          dataIndex: 'uom',
          key: 'uom',
          width: '100px',
          ellipsis: true,
          // Derived from the material master, never stored on the placement.
          render: (text, record) => record?.batch_detail?.material?.uom || '-',
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },
        {
          title: 'Qty',
          dataIndex: 'qty',
          key: 'qty',
          width: '100px',
          ellipsis: true,
          sorter: (a, b) => Number(a?.qty ?? 0) - Number(b?.qty ?? 0),
          // `??` not `||` — a captured qty of 0 must render as 0, while a legacy
          // placement (never captured, so NULL) renders as '-'.
          render: (text, record) => record?.qty ?? '-',
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },
        {
          title: 'Date of Receipt',
          dataIndex: 'document_verification',
          key: 'document_verification',
          width: '150px',
          sorter: (a, b) =>
            a?.batch_detail?.createdAt?.localeCompare(
              b?.batch_detail?.createdAt
            ),
          render: (text, record) => {
            return moment(record?.batch_detail?.createdAt).format(
              'DD MMM YYYY'
            );
          },
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        }
      ]
    : [
        {
          title: 'Bin Number',
          dataIndex: 'current_location',
          key: 'current_location',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) =>
            a?.current_location?.localeCompare(b?.current_location),
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },
        {
          title: 'Product Batch Number',
          dataIndex: 'prod_batch_no',
          key: 'prod_batch_no',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) => a?.number?.localeCompare(b?.number),
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
          render: (text, record) => {
            const dr =
              record?.prod_dispensing?.['dispensing-request'] ||
              record?.prod_dispensing?.dispensing_request;
            const sub = dr?.prod_label_sub_process?.sub_process_name;
            // Coating etc. carry process on the dispensing-request; Compression /
            // Inspection have no request, so fall back to the dispense's own
            // label process.
            const name =
              dr?.prod_label_process_master?.process_label_name ||
              record?.prod_dispensing?.label_process;
            const suffix =
              name || sub ? ` (${name || 'NA'}${sub ? ` › ${sub}` : ''})` : '';
            return `${text || 'NA'}${suffix}`;
          }
        },
        {
          title: 'Product Batch Name',
          dataIndex: 'prod_batch_name',
          key: 'prod_batch_name',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) => a?.number?.localeCompare(b?.number),
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
          render: (text, record) => {
            // product_id-linked dispenses use product_detail.name; Compression /
            // Inspection store the name on product_name instead.
            return (
              record?.prod_dispensing?.product_detail?.name ||
              record?.prod_dispensing?.product_name ||
              '-'
            );
          }
        },
        {
          title: 'Container No.',
          dataIndex: 'container_no',
          key: 'container_no',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) =>
            (a?.container_no || '').localeCompare(b?.container_no || ''),
          render: (text, record) => record?.container_no || '-',
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },
        {
          title: 'Area',
          dataIndex: 'area_name',
          key: 'area_name',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) =>
            (a?.area_name || '').localeCompare(b?.area_name || ''),
          render: (text, record) => record?.area_name || '-',
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },
        {
          title: 'Room',
          dataIndex: 'room_no',
          key: 'room_no',
          width: '150px',
          ellipsis: true,
          sorter: (a, b) => (a?.room_no || '').localeCompare(b?.room_no || ''),
          render: (text, record) => record?.room_no || '-',
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        },
        // Date of Receipt is not applicable for prod (prod bin locations carry no
        // document_verification). Show the date the bin location was inwarded instead.
        // {
        //   title: 'Date of Receipt',
        //   dataIndex: 'document_verification',
        //   key: 'document_verification',
        //   width: '150px',
        //   sorter: (a, b) =>
        //     a?.document_verification?.material?.createdAt?.localeCompare(
        //       b?.document_verification?.material?.createdAt
        //     ),
        //   render: (text, record) => {
        //     return moment(
        //       record?.document_verification?.material?.createdAt
        //     ).format('DD MMM YYYY');
        //   },
        //   responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        // }
        {
          title: 'Date of Inward',
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: '150px',
          sorter: (a, b) =>
            (a?.createdAt || '').localeCompare(b?.createdAt || ''),
          render: (text, record) => {
            return record?.createdAt
              ? moment(record?.createdAt).format('DD MMM YYYY')
              : 'NA';
          },
          responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
        }
      ];
  let locale = {
    emptyText: (
      <span>
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<span>There are no containers in this bin</span>}
        />
      </span>
    )
  };

  const handleConfirm = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleDispense = (value) => {
    const payload = { bin_numbers: selectedRowKeys, bin_no: value };
    dispatch(updatebinposition(payload)).then(function (response) {
      if (response?.payload?.success) {
        setTimeout(() => {
          form.resetFields();
          setData([]);
          setBindet('');
          setBinList(response?.payload?.data?.batch_bin_locations);
          setScan(false);
          history.push('/landingpage');
        });
      } else {
        setScan(false);
      }
    });
  };
  return (
    <Layout sider={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Card title="UPDATE BIN POSITION" className={styles.CustomPanel}>
          <Row gutter={24}>
            <Col xs={12} xl={4} span={4} style={{ paddingTop: '11px' }}>
              <h6 className={styles.lable}>Scan or search bin</h6>
            </Col>
            {bin == '' ? (
              <>
                <Col xs={10} xl={6} span={6}>
                  <FormItem
                    name="bin_containers"
                    rules={[
                      {
                        required: false,
                        message: 'Enter damaged containers'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Select
                      showSearch
                      placeholder="Scan or search bin"
                      optionFilterProp="children"
                      onChange={onChangebin}
                      onSearch={onSearchbin}
                    >
                      {binContainers.map((item, index) => {
                        return (
                          <option value={item.bin_number} key={index}>
                            {item.bin_number}
                          </option>
                        );
                      })}
                    </Select>
                  </FormItem>
                </Col>
                <Col xs={2} xl={2} span={2} md={2} sm={2}>
                  <CustomButton
                    onClick={() => setOpenCam(true)}
                    className={styles.qr}
                  >
                    <QrcodeOutlined onClick={() => setOpenCam(true)} />
                  </CustomButton>
                </Col>
              </>
            ) : (
              <>
                <Col xs={10} xl={6} span={6}>
                  <h6 className={styles.lableValue}>{bin}</h6>
                </Col>
                <Col xs={2} xl={2} span={2}>
                  <DeleteOutlined
                    onClick={() => setBin('')}
                    className={styles.removal}
                  />
                </Col>
              </>
            )}
          </Row>
          <Row gutter={24}>
            <Col xs={12} xl={4} span={4} style={{ paddingTop: '11px' }}>
              <h6 className={styles.lable}>Search Batch number</h6>
            </Col>
            {data?.length
              ? data?.map((item, index) => {
                  // Rows after the first need a leading spacer to sit under the
                  // "Search Batch number" label column. Warehouse rows also carry
                  // the material's UOM and a per-placement Qty input.
                  //
                  // Production has no material code, so it renders batch and
                  // product name only. The old markup emitted the material-code
                  // cell anyway from the second row on, leaving a permanently
                  // blank field between the two.
                  return (
                    <React.Fragment key={index}>
                      {index === 0 ? '' : <Col xs={12} xl={4} span={4}></Col>}
                      <Col xs={10} xl={!isProdRole ? 5 : 8} span={6}>
                        <h6 className={styles.lableValue}>
                          {item?.[0]?.batch}
                        </h6>
                      </Col>
                      {!isProdRole ? (
                        <Col xs={10} xl={4} span={6}>
                          <h6 className={styles.lableValue}>
                            {item?.[0]?.material_id}
                          </h6>
                        </Col>
                      ) : (
                        ''
                      )}
                      <Col xs={10} xl={!isProdRole ? 5 : 8} span={6}>
                        <h6 className={styles.lableValue}>
                          {item?.[0]?.material_name}
                        </h6>
                      </Col>
                      {!isProdRole ? (
                        <>
                          <Col xs={4} xl={2} span={3}>
                            <h6 className={styles.lableValue}>
                              {item?.[0]?.uom || '-'}
                            </h6>
                          </Col>
                          <Col xs={8} xl={3} span={4}>
                            <InputNumber
                              min={0}
                              precision={3}
                              style={{ width: '100%' }}
                              placeholder="Qty"
                              value={item?.[0]?.qty}
                              onChange={(value) =>
                                handleQtyChange(value, index)
                              }
                            />
                          </Col>
                        </>
                      ) : (
                        ''
                      )}
                      <Col xs={2} xl={!isProdRole ? 1 : 2} span={2}>
                        {/* delete stays xl=2 for prod, matching the old markup */}
                        <DeleteOutlined
                          onClick={() => removeConatiner(index)}
                          className={styles.removal}
                        />
                      </Col>
                    </React.Fragment>
                  );
                })
              : ''}
            {data?.length ? (
              <Col xs={12} xl={4} span={4} md={12} sm={12}></Col>
            ) : (
              ''
            )}
            <Col xs={10} xl={6} span={6}>
              <FormItem
                name="batch_number"
                rules={[
                  {
                    required: false,
                    message: 'Enter damaged containers'
                  }
                ]}
                className={styles.customLable}
              >
                {isProdRole ? (
                  <Select
                    showSearch
                    placeholder="Search product numbers"
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                  >
                    {containers.map((item, index) => {
                      return (
                        <option value={item.id} key={index}>
                          {formatProdBatchLabel(item)}
                        </option>
                      );
                    })}
                  </Select>
                ) : (
                  <Select
                    showSearch
                    placeholder="Search batch numbers"
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                  >
                    {containers.map((item, index) => {
                      return (
                        <option value={item.id} key={index}>
                          {item.inhouse_batch_number}
                        </option>
                      );
                    })}
                  </Select>
                )}
              </FormItem>
            </Col>
            {/* <Col xs={2} xl={2} span={2} md={2} sm={2}>
              <CustomButton
                onClick={() => setOpenConatCam(true)}
                className={styles.qr}
              >
                <QrcodeOutlined onClick={() => setOpenConatCam(true)} />
              </CustomButton>
            </Col> */}
          </Row>
          <FormItem className="text-center">
            <Space size={5}>
              {scan ? (
                <Image
                  src={scanning}
                  preview={false}
                  style={{ width: '100px !important', height: '100px' }}
                />
              ) : (
                <CustomButton
                  className={styles.inwardButton}
                  htmlType="submit"
                  type="primary"
                  disabled={data?.length ? false : true}
                >
                  Add & Scan Next Bin
                </CustomButton>
              )}
            </Space>
          </FormItem>
        </Card>
        {bindata ? (
          <>
            <Card
              title={<span>CONTAINER/BIN DETAIL</span>}
              className={`${styles.cardStyles_approver}`}
            >
              <div className={`${styles.table_container}`}>
                <CustomTable
                  className={styles.tableStyles}
                  columns={columns}
                  dataSource={pagedBinList}
                  // className={styles.scrolling}
                  rowSelection={rowSelection}
                  rowKey={(record) => record.id}
                  scroll={{ x: 'auto' }}
                  locale={locale}
                  showPaginationMeta
                  pagination={{
                    size: 'small',
                    total: (binList || []).length,
                    current: page,
                    pageSize: pageSize,
                    onChange: (newPage, newSize) => {
                      if (newSize !== pageSize) {
                        setPageSize(newSize);
                        setPage(1);
                      } else {
                        setPage(newPage);
                      }
                    }
                  }}
                />
              </div>
              <FormItem className="text-center">
                <Space>
                  {/* For prod_ebmr, Move to Production Area / Move to WIP Area are
                      now handled from the Outward register submit modal, so they
                      are hidden here. Warehouse roles keep Dispense / Sampling. */}
                  {!isProdRole && (
                    <>
                      <CustomButton
                        type="primary"
                        ghost
                        onClick={() => handleDispense('Dispensed')}
                      >
                        Move to Dispense
                      </CustomButton>
                      <CustomButton
                        type="primary"
                        ghost
                        onClick={() => handleDispense('Sampled')}
                      >
                        Move to Sampling
                      </CustomButton>
                    </>
                  )}
                  <CustomButton type="primary" onClick={() => setBincard(true)}>
                    Move to Bin
                  </CustomButton>
                  {/* {user?.level === 3 && (
                    <CustomButton
                      type="primary"
                      onClick={() => setIsmodal(true)}
                    >
                      Remove Bin
                    </CustomButton>
                  )} */}
                </Space>
              </FormItem>
            </Card>
            <br />
          </>
        ) : (
          ''
        )}

        {bincard ? (
          <Card className={`${styles.cardStyles_approver1}`}>
            <Row gutter={24}>
              <Col xs={12} xl={16} span={16} style={{ paddingTop: '11px' }}>
                <h6 className={styles.lable}>Scan or search bin</h6>
              </Col>
              {bindet == '' ? (
                <>
                  <Col xs={10} xl={6} span={6}>
                    <FormItem
                      name="bin_containers"
                      rules={[
                        {
                          required: false,
                          message: 'Enter damaged containers'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        showSearch
                        placeholder="Scan or Select bin"
                        optionFilterProp="children"
                        onChange={onChangebinnum}
                        onSearch={onSearchbin}
                      >
                        {binContainers.map((item, index) => {
                          return (
                            <option value={item.bin_number} key={index}>
                              {item.bin_number}
                            </option>
                          );
                        })}
                      </Select>
                    </FormItem>
                  </Col>
                  <Col xs={2} xl={2} span={2} md={2} sm={2}>
                    <CustomButton
                      onClick={() => setOpenCam(true)}
                      className={styles.qr}
                    >
                      <QrcodeOutlined onClick={() => setOpenCam(true)} />
                    </CustomButton>
                  </Col>
                </>
              ) : (
                <>
                  <Col xs={10} xl={6} span={6}>
                    <h6 className={styles.lableValue}>{bindet}</h6>
                  </Col>
                  <Col xs={2} xl={2} span={2}>
                    <DeleteOutlined
                      onClick={() => setBindet('')}
                      className={styles.removal}
                    />
                  </Col>
                </>
              )}
            </Row>
            <br />
            <FormItem className="text-center">
              <Space size={5}>
                <CustomButton type="primary" onClick={() => history.back()}>
                  Back
                </CustomButton>
                <CustomButton
                  type="primary"
                  // htmlType="submit"
                  disabled={bin ? false : true}
                  onClick={handleBinPosition}
                >
                  Update Bin
                </CustomButton>
              </Space>
            </FormItem>
          </Card>
        ) : (
          ''
        )}

        {openCam ? (
          <QrReader
            constraints={{ facingMode: 'environment' }}
            delay={1000}
            onError={handleError}
            onResult={(result) => handleQrScan(result)}
            // chooseDeviceId={()=>selected}
            style={{ width: '3px', height: '3px' }}
          />
        ) : (
          ''
        )}
        {openConatCam ? (
          <QrReader
            constraints={{ facingMode: 'environment' }}
            delay={1000}
            onError={handleError}
            onResult={(result) => handleContainerQrScan(result)}
            // chooseDeviceId={()=>selected}
            style={{ width: '3px', height: '3px' }}
          />
        ) : (
          ''
        )}
        <br />
        <FormItem className="text-center">
          <Space size={5}>
            <CustomButton
              className={styles.inwardButton}
              type="primary"
              onClick={() => history.back()}
            >
              Back to Home
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
      {ismodal ? (
        <CustomModal
          // title="Release Notes"
          visible={ismodal}
          width="45%"
          footer={null}
          className={styles.customModal}
          closable={false}
        >
          <Card>
            <h5>
              Are you sure you want to remove the Bin location for the selected
              Containers?
            </h5>
            <FormItem
              name="bin_containers"
              rules={[
                {
                  required: false,
                  message: 'Enter damaged containers'
                }
              ]}
              className={styles.customLable}
            >
              <Checkbox onChange={(e) => handleConfirm(e)} /> Yes, I confirm
              that the selected containers are empty.
            </FormItem>
            <FormItem className="text-center">
              <Space>
                <CustomButton
                  className={styles.inwardButton}
                  onClick={() => handleClose()}
                  type="primary"
                  ghost
                >
                  Close
                </CustomButton>
                <CustomButton
                  className={styles.inwardButton}
                  // htmlType="submit"
                  type="primary"
                  onClick={() => handleSubmit()}
                  disabled={!isChecked}
                >
                  Delete
                </CustomButton>
              </Space>
            </FormItem>
          </Card>
        </CustomModal>
      ) : (
        ''
      )}
    </Layout>
  );
};
export default UpdateBinPage;
